import React from 'react';
import AboutImage from './AboutImage';
import { ABOUT_PLACEHOLDER_IMAGES } from '../../utils/aboutLayoutDefaults';
import './about.css';

const AboutHistorySection = ({ data }) => {
    if (!data) return null;

    const items = data.historyItems || [];
    if (items.length === 0) return null;

    return (
        <section className="w-full bg-white py-10 lg:py-14 about-section-divider">
            <div className="about-shell">
                <h2 className="text-lg md:text-xl font-black text-slate-900 uppercase tracking-tight text-center mb-8">
                    {data.historyTitle || 'LỊCH SỬ HÌNH THÀNH VÀ PHÁT TRIỂN'}
                </h2>

                <div className="w-full overflow-x-auto pb-2">
                    <div className="min-w-[640px]">
                        {/* 1. Hàng 5 Ảnh */}
                        <div className="grid grid-cols-5 gap-3 md:gap-4 mb-4">
                            {items.map((item, i) => (
                                <div key={`tl-img-${i}`} className="about-media-box about-media-box--timeline min-w-0">
                                    <AboutImage
                                        src={item.imageUrl}
                                        fallback={ABOUT_PLACEHOLDER_IMAGES.timeline[i % ABOUT_PLACEHOLDER_IMAGES.timeline.length]}
                                        alt={item.year || `Mốc ${i + 1}`}
                                        variant="cover"
                                    />
                                </div>
                            ))}
                        </div>

                        {/* 2. Đường kẻ đỏ + 5 Nút chấm tròn đỏ */}
                        <div className="relative flex items-center justify-around h-6 my-2">
                            <div className="absolute top-1/2 left-[10%] right-[10%] h-[2px] bg-[#E31E24] -translate-y-1/2 z-0" />
                            {items.map((_, i) => (
                                <div key={`tl-dot-${i}`} className="relative z-10 flex items-center justify-center">
                                    <div className="w-3.5 h-3.5 rounded-full bg-[#E31E24] border-2 border-white ring-1 ring-[#E31E24]" />
                                </div>
                            ))}
                        </div>

                        {/* 3. Hàng Chữ Mốc thời gian & Mô tả */}
                        <div className="grid grid-cols-5 gap-3 md:gap-4 mt-3">
                            {items.map((item, i) => (
                                <div key={`tl-text-${i}`} className="text-center px-1 min-w-0">
                                    {item.year && (
                                        <h3 className="text-sm md:text-base font-extrabold text-[#E31E24] mb-1">
                                            {item.year}
                                        </h3>
                                    )}
                                    {item.description && (
                                        <p className="text-[11px] md:text-xs text-slate-600 leading-snug text-center">
                                            {item.description}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutHistorySection;
